import Debug from './_debug';
import $ from 'jquery';
import getSlug from 'speakingurl';

let ScrollspyMenu = {};
ScrollspyMenu.titles = [];  

ScrollspyMenu.initialize = () => {
  Debug.log('ScrollspyMenu: initialize');

  if ($('.diseases-template').length > 0) {
    Debug.log('ScrollspyMenu: diseases template detected => render');
    ScrollspyMenu.getTitles();
    ScrollspyMenu.renderMenu();
  }
}

ScrollspyMenu.renderMenu = () => {
  let html = '';
  html += '<nav id="diseases-navbar" class="navbar diseases-navbar sticky-top">';
  
  ScrollspyMenu.titles.each(function(index, title) {
    let titleSlug = getSlug($(title).text());
    titleSlug = titleSlug.replace(/[0-9]/g, '-');
    $(title).attr('id', titleSlug);

    html += '<nav class="nav nav-pills flex-column col-12">';
    html += '<a class="nav-link" href="#' + titleSlug + '">' + $(title).text() + '</a>';
    html += '</nav>';

  });

  html += '</nav>';

  $('#diseases-nav-wrapper').append(html);
  ScrollspyMenu.enableScrollspy();
  ScrollspyMenu.handleNavLinks();
}

ScrollspyMenu.getTitles = () => {
  ScrollspyMenu.titles = $('h2').not( ".no-menu" );
}

ScrollspyMenu.enableScrollspy = () => {
  const headerHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * (8 + 2.5); // 8 rem
  $('body').scrollspy({ target: '#diseases-navbar', offset: headerHeight });
};

ScrollspyMenu.handleNavLinks = () => {
  const headerHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * (8 + 2); // 8 rem

  $('#diseases-navbar .nav-link').on('click', function(event) {
    event.preventDefault();
    var target = this.hash;
    var $target = $(target);

    $('html, body').stop().animate({
      scrollTop: $target.offset().top - headerHeight
    }, 800, 'swing', function() {
      history.replaceState(null, null, target);
    });
  });
};


export default ScrollspyMenu;